import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProgressService {
  private activeCount = 0;
  started = false;

  @Output() startProgress: EventEmitter<boolean> = new EventEmitter();
  @Output() completeProgress: EventEmitter<boolean> = new EventEmitter();

  constructor() { }

  start() {
    this.activeCount = Math.max(0, this.activeCount) + 1;
    if (!this.started) {
      this.started = true;
      this.startProgress.emit(this.started);
    }
  }

  complete() {
    this.activeCount = Math.max(0, this.activeCount - 1);
    if (this.activeCount <= 0 && this.started) {
      this.started = false;
      this.completeProgress.emit(this.started);
    }
  }
}
